<template>
  <div class="font_icon_store">
    <div class="tabPart" v-if="$store.state.app.road_type !== 1">
      <ul class="tablist clearfix" :style="{
        left: isTypeLeft ? '0px' : '-648px',
        transition: `left 0.3s ease 0s`
      }">
        <li class="tabLine" v-for="item in typeList.left"
            v-show="isTypeLeft"
            :key="item.type"
            :class="{selected:item.type === seTypeId}"
            @click='changeType(item)'>
          <p>{{ item.type_name }}</p>
        </li>
        <li class="tabLine" v-for="item in typeList.right"
            v-show="!isTypeLeft"
            :key="item.type"
            :class="{selected:item.type === seTypeId}"
            @click='changeType(item)'>
          <p>{{ item.type_name }}</p>
        </li>
        <i class="icon_btn" :class="isTypeLeft ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"
           @click="slideType"></i>
      </ul>
    </div>
    <div class="iconPart" v-loading='isloading' v-if="fontIconList.length !== 0">
      <div class="iconContent">
        <ul class="clearfix">
          <li class="iconLine" v-for="(icon,index) in currentList" :key="index" @click="selectIcon(icon)">
            <div class="iconBox" :class="{active:selectIconList == icon}">
              <i :class="$store.state.app.road_type !== 1 ? `fa fa-2x fa-${icon}`: `iconfont ${icon}`"
                 aria-hidden="true"></i>
              <span class="activeIcon el-icon-check"></span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="noDataTip" v-if="fontIconList.length === 0">
      <p>{{$t('components_my_img_selecter_font_icon_store_2318')}}</p>
    </div>
    <div class="img-store-footer">
      <el-button class="btn-footer-confirm" type="primary" size="small" @click="onClickConfirmBtn">{{$t('view_public_topbar_24')}}</el-button>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import {font_icon_config} from '@/base/font_icon_config'

export default {
  data() {
    return {
      fontIconList: this.$store.state.app.road_type !== 1 ? font_icon_config().list : font_icon_config().ampList, // 图标列表
      currentList: this.$store.state.app.road_type !== 1 ? font_icon_config().list[0].children : font_icon_config().ampList[0].children, //当前图标列表
      seTypeId: 'web-application',
      isloading: false,
      checkList: this.firstModel,
      selectIconList: this.firstModel,
      isTypeLeft: true
    };
  },
  computed: {
    typeList() {
      return {
        left: this.fontIconList.filter((item, index) => index < 8),
        right: this.fontIconList.filter((item, index) => index >= 8)
      }
    },
  },
  methods: {
    slideType() {
      this.isTypeLeft = !this.isTypeLeft
    },
    changeType(item) {
      this.seTypeId = item.type
      this.currentList = []
      this.currentList = item.children
    },
    selectIcon(item) {
      if (!~this.selectIconList.indexOf(item)) {
        if (this.limitnum === 1) {
          this.selectIconList = []
          this.checkList = []
        }
        this.selectIconList = item
        this.checkList.push(item)
      } else {
        this.selectIconList = []
        this.checkList = []
      }
    },
    onClickConfirmBtn() {
      if (![this.$store.state.image_upload.TYPE_IMG].includes(this.$store.state.image_upload.fileType)) {
        this.$message.warning(i18n.t('components_my_img_selecter_font_icon_store_2319'))
      }
      if (this.$store.state.image_upload.fileLimit < this.checkList.length) {
        this.$message.warning(i18n.t('components_my_img_selecter_font_icon_store_2320') + this.$store.state.image_upload.fileLimit + i18n.t('components_my_img_selecter_font_icon_store_2321'))
      }
      console.log('this.checkList:', this.checkList)
      this.$store.state.image_upload.imgFile(this.checkList)
      this.closeDialog()
    },
    closeDialog() {
      this.$store.commit('image_upload/set_showTag', false);
      this.$store.commit("image_upload/set_showFontIcon", false);
      this.$store.commit("image_upload/set_showIconLibrary", false);
    }
  },
  props: {
    firstModel: {
      // 第一个字段的值（v-model)
      type: Array,
      default: function () {
        return []
      }
    },
    //最大数量
    limitnum: {
      type: Number,
      default: 1
    },
  },
  watch: {
    checkList(val, oldVal) {
      // 数据双向绑定
      this.$emit('update:firstModel', val);
    },
    firstModel(val) {
      // 数据双向绑定
      this.checkList = val;
    },
  },
  mounted() {
    this.isloading = true
    this.$nextTick(() => {
      this.isloading = false
    })
  }
};
</script>

<style lang="scss" scoped>
.iconfont {
  font-size: 25px !important;
}

.page {
  margin-top: 10px;
  text-align: center;
}

.font_icon_store {
  font-size: 12px;
  width: auto;
  padding: 10px 20px 10px 20px;

  .tabPart {
    width: 720px;

    .tablist {
      overflow: hidden;
      margin: 10px -10px 12px 0;

      .icon_btn {
        font-size: 15px;
        vertical-align: middle;
        padding-top: 5px;
        cursor: pointer;
        float: right;
      }
    }
  }

  .tabLine {
    margin: 0 18px 10px 0;
    height: 23px;
    line-height: 23px;
    cursor: pointer;
    border: 1px solid #fff;
    text-decoration: none;
    float: left;
    color: #333;
    font-size: 14px;
  }

  .tabLine.selected {
    color: #557ce1
  }

  .noDataTip {
    height: 420px;
    line-height: 420px;
    text-align: center;
    font-size: 30px;
  }

  .iconPart {
    height: 420px;
    overflow: hidden;
    overflow-y: auto;

    .iconLine {
      float: left;
      margin-right: 24px;
      margin-bottom: 27px;
      list-style: none;
    }

    .iconBox {
      position: relative;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 40px;
      height: 40px;
      background: #f3f3f3;

      .activeIcon {
        display: none;
        width: 18px;
        height: 16px;
        color: #fff;
        position: absolute;
        bottom: 0;
        right: 0;
        background-color: #5874d8;
        line-height: 22px;
        font-size: 12px;
        padding: 0 3px;
        border-top-left-radius: 100%;
      }

      &.active {
        border: 1px solid #5874d8;

        .activeIcon {
          display: block;
        }
      }
    }

    .iconBox:hover {
      border: 1px solid #5874d8;
    }
  }
}

.showPart {
  padding: 30px 30px 20px 28px;
}

.img-store-footer {
  display: flex;
  justify-content: flex-end;
}

.btn-footer-confirm {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/my_img_selecter/font_icon_store.vue